import { FC } from 'react';
import { useTranslate } from 'hooks/useTranslate';

import { formatNumber, formatNumberDecimals } from 'utils/formats';

import { RowCell } from 'modules/_shared/Table/types/RowCell';
import TableRow from 'modules/_shared/Table/components/TableRow';

import { HistoryMovement } from 'types';

import movementTypes from 'modules/transactions/constants/movementTypes';
import { isShareClassVisible } from 'modules/trading/utils/isShareClassVisible';

type SharesTransferTableRowProps = {
  movement: HistoryMovement;
  index: number;
};

const SharesTransferTableRow: FC<SharesTransferTableRowProps> = ({
  movement,
  index,
}) => {
  const { t } = useTranslate();

  const isTransferAllMovement =
    movement?.movementType === movementTypes.TRANSFER_ALL;

  const cells = [
    {
      key: `movement-partner-seller-${index}`,
      content: movement.partnerNameSeller,
      textPosition: 'left',
    },
    {
      key: `movement-partner-buyer-${index}`,
      content: movement.partnerNameBuyer,
      textPosition: 'left',
    },
    isShareClassVisible()
      ? {
          key: `movement-class-${index}`,
          content: movement.holdingClassName,
          textPosition: 'center',
        }
      : null,
    {
      key: `movement-price-${index}`,
      content: formatNumberDecimals(movement.sharePrice),
      textPosition: 'right',
    },
    ...(isTransferAllMovement
      ? [
          {
            key: `movement-type-${index}`,
            content: t('AllShares'),
            textPosition: 'center',
            colSpan: 2,
          },
        ]
      : [
          {
            key: `movement-from-${index}`,
            content: formatNumber(movement.from),
            textPosition: 'right',
          },
          {
            key: `movement-to-${index}`,
            content: formatNumber(movement.to),
            textPosition: 'right',
          },
        ]),

    {
      key: `movement-action-${index}`,
      content: '',
      textPosition: 'right',
    },
  ].filter(Boolean) as RowCell[];

  return <TableRow cells={cells} />;
};

export default SharesTransferTableRow;
